import { useEffect } from 'react';

/**
 * ページの robots メタタグを動的に設定するフック
 * @param content - robots メタタグの content 属性値（例: "index,follow", "noindex,nofollow"）
 * デフォルト: "noindex,nofollow" → CloudFront のデフォルトヘッダーと同調
 * 
 * 使用例:
 *   // マーケージページで検索インデックスを許可
 *   export const Home: FC = () => {
 *     useRobotsMeta('index,follow');
 *     return <div>...</div>;
 *   };
 *
 *   // アプリページで明示的に noindex を指定（二重化）
 *   export const Dashboard: FC = () => {
 *     useRobotsMeta('noindex,nofollow');
 *     return <div>...</div>;
 *   };
 */
export function useRobotsMeta(content: string = 'noindex,nofollow'): void {
  useEffect(() => {
    // 既存の robots メタタグを探す
    let metaRobots = document.querySelector('meta[name="robots"]');

    // なければ作成
    if (!metaRobots) {
      metaRobots = document.createElement('meta');
      metaRobots.setAttribute('name', 'robots');
      document.head.appendChild(metaRobots);
    }

    // content を設定
    metaRobots.setAttribute('content', content);

    // クリーンアップ: アンマウント時にメタタグを削除（オプション）
    // return () => {
    //   metaRobots?.remove();
    // };
  }, [content]);
}
